import Http from './http'

let BaseUrl
if (process.env.NODE_ENV === 'development') {
  // BaseUrl = '/api'
  BaseUrl = 'https://cx.istemedu.com'
} else {
  BaseUrl = 'https://cx.istemedu.com'
}
export function getApplabCategory(data) {
  return Http({
    url: BaseUrl + `/api/v1/tank/applab/category`,
    method: 'get',
    params: data
  })
}

export function getApplab(id, data) {
  return Http({
    url: BaseUrl + `/api/tank/applab/${id}`,
    method: 'get',
    params: data
  })
}

export function getApplabList(data) {
  return Http({
    url: BaseUrl + `/api/v1/tank/applab/list`,
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js